import {http} from '../../axios'
// import router from "../../router";
import main from "./main";
import characteristicsSchedule from "./characteristicsSchedule";
import characteristicsSalary from "./characteristicsSalary";
import characteristicsInhabitancy from "./characteristicsInhabitancy";
import characteristicsDynamicParams from "./characteristicsDynamicParams";
import characteristicsAdditional from "./characteristicsAdditional";
import workPlace from "./workPlace";
import requirements from "./requirements";
import files from "./files";
import images from "./images";

function getInitState() {
  return {
    muted: false,
    loaded: false,
    pendingLoad: false,
    pendingSave: false,
    saveOnly: true,
    error: null,
    vacancy: null,
    jobTypes: null,
    salary: null,
  }
}

export default {
  namespaced: true,
  modules: {
    main,
    characteristicsSchedule,
    characteristicsSalary,
    characteristicsInhabitancy,
    characteristicsDynamicParams,
    characteristicsAdditional,
    workPlace,
    requirements,
    files,
    images
  },
  state: getInitState(),
  mutations: {
    setPendingSave(state, value) {
      state.pendingSave = value
    },
    setPendingLoad(state, value) {
      state.pendingLoad = value
    },
    setLoaded(state, value) {
      state.loaded = value
    },
    setSaveOnly(state, value) {
      state.saveOnly = value
    },
    setError(state, value) {
      state.error = value
    },
    setVacancy(state, value) {
      state.vacancy = value
    },
    setJobTypes(state, value) {
      state.jobTypes = value
    },
    setSalary(state, value) {
      state.salary = value
    },
    //RESET
    resetState(state) {
      Object.assign(state, getInitState())
    },
  },
  actions: {
    resetState({commit}) {
      commit('resetState')
      commit('main/resetState')
      commit('characteristicsSchedule/resetState')
      commit('characteristicsSalary/resetState')
      commit('characteristicsInhabitancy/resetState')
      commit('characteristicsDynamicParams/resetState')
      commit('characteristicsAdditional/resetState')
      commit('workPlace/resetState')
      commit('requirements/resetState')
      commit('files/resetState')
      commit('images/resetState')
    },
    async saveAll({state, commit, dispatch}, {withPost, vacancyId}) {
      commit('main/resetErrors')
      let isRequiredFilled = await dispatch('main/moderateFieldsIsRequired', 'inputs')

      if (!isRequiredFilled) {
        commit('setError', 'Required fields can`t be empty')
        return Promise.reject('Required fields can`t be empty')
      } else {
        commit('setError', null)
      }

      commit('setPendingSave', true)
      const sendDataMain = {
        vacancy: createSendData(state.main.inputs),
        salary: await dispatch('getSalary'),
        job_types: await dispatch('getJobTypes'),
        char_schedule: await dispatch('getCharacteristicsSchedule'),
        char_salary: await dispatch('getCharacteristicsSalary'),
        char_inhabitancy: await dispatch('getCharacteristicsInhabitancy'),
        params: await dispatch('getCharacteristicsDynamicParams'),
        char_additional_info: await dispatch('getCharacteristicsAdditional'),
        workplace: await dispatch('getWorkPlace'),
        applicant_requirements: await dispatch('getRequirements')
      }

      sendDataMain.vacancy.only_save = !withPost
      commit('setSaveOnly', !withPost)

      let method = vacancyId ? 'patch' : 'post'
      let routeVacancyId = vacancyId ? '/' + vacancyId : ''

      return http[method](`/api/vacancyAll${routeVacancyId}`, sendDataMain).then(({data}) => {
        commit('setVacancy', data.data)
        return data
      }).then(async (data) => {
        const request = [
          dispatch('files/upload', state.vacancy.id),
        ]

        if (vacancyId) {
          request.push(dispatch('images/updateFiles', state.vacancy.id))
        } else {
          request.push(dispatch('images/upload', state.vacancy.id),)
        }
        await Promise.all(request)

        return data
      }).catch(e => {
        if (!e.response || !e.response.data) {
          commit('setError', [e.message])
          return e
        }

        if (!e.response.data.errors && !e.response.data.message) {
          commit('setError', [e.message])
          return e
        }

        if (e.response.data.errors) {
          commit('setError', e.response.data.errors)
        }

        if (e.response.data.message) {
          commit('setError', e.response.data.message)
        }

        throw e
      }).finally(() => {
        commit('setPendingSave', false)
      })
    },
    getJobTypes({state}) {
      return state.main.jobTypes.job_types
    },
    getSalary({state}) {
      return createSendData(state.main.salaryInputs)
    },
    getCharacteristicsSchedule({state}) {
      if (!state.characteristicsSchedule.muted) return
      const sendData = createSendData(state.characteristicsSchedule.inputs)
      sendData.shifts = state.characteristicsSchedule.shifts
      return sendData
    },
    getCharacteristicsSalary({state}) {
      if (!state.characteristicsSalary.muted) return
      return createSendData(state.characteristicsSalary.inputs)
    },
    getCharacteristicsInhabitancy({state}) {
      if (!state.characteristicsInhabitancy.muted) return
      return createSendData(state.characteristicsInhabitancy.inputs)
    },
    getCharacteristicsDynamicParams({state}) {
      if (!state.characteristicsDynamicParams.muted) return
      return JSON.stringify(state.characteristicsDynamicParams.resultParams || {})
    },
    getCharacteristicsAdditional({state}) {
      if (!state.characteristicsAdditional.muted) return
      if (!state.characteristicsAdditional.inputs.comment.value) return

      return state.characteristicsAdditional.inputs.comment.value
    },
    getWorkPlace({state}) {
      if (!state.workPlace.muted) return
      return createSendData(state.workPlace.inputs)
    },
    getRequirements({state}) {
      if (!state.requirements.muted) return
      return createSendData(state.requirements.inputs)
    },

    // - - - -

    saveJobTypes({state, commit}) {
      if (!state.vacancy) return
      const sendData = {job_types: state.main.jobTypes.job_types}

      return http.post(`/api/vacancy/${state.vacancy.id}/job-types`, sendData).then(({data}) => {
        // console.log('/api/vacancy', data)
        commit('setJobTypes', data.data)
      })
    },
    saveSalary({state, commit}) {
      if (!state.vacancy) return
      const sendData = createSendData(state.main.salaryInputs)

      return http.put(`/api/vacancy/${state.vacancy.id}/salary`, sendData).then(({data}) => {
        commit('setSalary', data.data)
      })
    },
    saveCharacteristicsSalary({state}) {
      if (!state.vacancy || !state.characteristicsSalary.muted) return
      const sendData = createSendData(state.characteristicsSalary.inputs)

      return http.post(`/api/vacancy/${state.vacancy.id}/chars/salary`, sendData).then(() => {
        // commit('setSalary', data.data)
      })
    },
    saveCharacteristicsInhabitancy({state}) {
      if (!state.vacancy || !state.characteristicsInhabitancy.muted) return
      const sendData = createSendData(state.characteristicsInhabitancy.inputs)

      return http.post(`/api/vacancy/${state.vacancy.id}/chars/inhabitancy`, sendData).then(() => {
        // commit('setSalary', data.data)
      })
    },
    // saveCharacteristicsDynamicParams({state}) {
    //   if (!state.vacancy) return
    //   const sendData = {
    //     params: JSON.stringify(state.characteristicsDynamicParams.resultParams || {})
    //   }
    //
    //   return http.post(`/api/vacancy/${state.vacancy.id}/params`,null, {
    //     params: {
    //       params: sendData
    //     }
    //   }).then(() => {
    //
    //     // commit('setSalary', data.data)
    //   })
    // },
    saveCharacteristicsDynamicParams({state}) {
      if (!state.vacancy || !state.characteristicsDynamicParams.muted) return
      const sendData = {
        params: JSON.stringify(state.characteristicsDynamicParams.resultParams || {})
      }

      return http.post(`/api/vacancy/${state.vacancy.id}/params`, sendData,).then(() => {

        // commit('setSalary', data.data)
      })
    },
    saveCharacteristicsAdditional({state}) {
      if (!state.vacancy || !state.characteristicsAdditional.muted) return
      if (!state.characteristicsAdditional.inputs.comment.value) return

      const sendData = {
        char_additional_info: state.characteristicsAdditional.inputs.comment.value
      }

      return http.post(`/api/vacancy/${state.vacancy.id}/chars/additional-info`, sendData).then(() => {
        // commit('setSalary', data.data)
      })
    },
    saveWorkPlace({state}) {
      if (!state.vacancy || !state.workPlace.muted) return
      const sendData = createSendData(state.workPlace.inputs)

      return http.post(`/api/vacancy/${state.vacancy.id}/workplace`, sendData).then(() => {
        // commit('setSalary', data.data)
      })
    },
    saveRequirements({state}) {
      if (!state.vacancy || !state.requirements.muted) return
      const sendData = createSendData(state.requirements.inputs)

      return http.post(`/api/vacancy/${state.vacancy.id}/applicant-requirements`, sendData).then(() => {
        // commit('setSalary', data.data)
      })
    },
    loadVacancy({commit, dispatch}, id) {
      commit('setPendingLoad', true)
      commit('setLoaded', false)

      return http.get(`/api/vacancy-edit/${id}`).then(({data}) => {
        commit('setVacancy', data.data)
        dispatch('main/setVacancyValues', data.data)
        dispatch('characteristicsSchedule/setVacancyValues', data.data)
        dispatch('characteristicsSalary/setVacancyValues', data.data)
        dispatch('characteristicsInhabitancy/setVacancyValues', data.data)
        dispatch('characteristicsDynamicParams/setVacancyValues', data.data)
        dispatch('characteristicsAdditional/setVacancyValues', data.data)
        dispatch('workPlace/setVacancyValues', data.data)
        dispatch('requirements/setVacancyValues', data.data)
        dispatch('files/setVacancyValues', data.data)
        dispatch('images/setVacancyValues', data.data)
      }).then(() => {
        commit('setLoaded', true)
      }).finally(() => {
        commit('setPendingLoad', false)
      })
    },

    subscribeMutation({commit, state}) {
      const modulesNames = [
        'main',
        'characteristicsSchedule',
        'characteristicsSalary',
        'characteristicsInhabitancy',
        'characteristicsDynamicParams',
        'characteristicsAdditional',
        'workPlace',
        'requirements',
        'files',
        'images',
      ]

      modulesNames.forEach(name => {
        const prefix = `vacancyEdit/${name}/`
        const mutationsSubscribeNames = state[name].mutationsSubscribeNames
        if (!Array.isArray(mutationsSubscribeNames)) return
        const mutationNames = state[name].mutationsSubscribeNames.map(name => (prefix + name))

        this.subscribe((mutation) => {
          if (mutationNames.includes(mutation.type)) {
            commit(name + '/setMuted', true)
          }
        })
      })
    }
  }
}


function createSendData(inputs) {
  const data = {}

  for (const [key, obj] of Object.entries(inputs)) {
    let value
    if (obj.value instanceof Date) {
      value = obj.value.toISOString()
    } else if (obj.value && obj.value.id) {
      value = obj.value.id
    } else {
      value = obj.value
    }

    data[key] = value
  }

  return data
}


